<script>
export default {
  props: {
    active: { default: false },
    step: { default: 1 },
    skip: { default: false },
    enter: { default: 'fadeIn' },
    enterPrev: { default: 'slideInLeft' },
    enterNext: { default: 'slideInRight' },
    leave: { default: 'fadeOut' },
    leavePrev: { default: 'slideOutRight' },
    leaveNext: { default: 'slideOutLeft' },
    mouseNavigation: { default: true },
    keyboardNavigation: { default: true }
  },
  data () {
    return {
      isSlide: true,
      slideTimer: 0,
      transitions: {
        next: {
          enter: this.enterNext || this.enter,
          leave: this.leaveNext || this.leave
        },
        prev: {
          enter: this.enterPrev || this.enter,
          leave: this.leavePrev || this.leave
        }
      }
    }
  },
  computed: {
    templateComponent () {
      return this.$children[0]
    },
    isNextOrPrev () {
      const currentSlide = this.event.position.currentSlide
      return currentSlide === this.slide.order || currentSlide + 2 === this.slide.order
    },
    showSlide () {
      return this.active || this.editing || this.preview
    },
    direction () {
      const parent = this.findParentByName('SlideshowComponent')
      if (parent) {
        return parent.direction || 'next'
      } else {
        return this.$root.direction || 'next'
      }
    },
    enterTransition () {
      return this.transitions[this.direction].enter
    },
    leaveTransition () {
      return this.transitions[this.direction].leave
    }
  },
  watch: {
  },
  methods: {
  }
}
</script>
